import { useSesion } from "../sesion";
import { InicioCampanas } from "../campanas/InicioCampanas";
import { Tablero } from "../tickets/Tablero";

/** La portada depende de la vista: el Semáforo abre en el tablero ejecutivo; 360, en el inicio de campañas. */
export function Inicio() {
  const { configuracion } = useSesion();
  const esSemaforo = configuracion?.vista === "semaforo";
  return esSemaforo ? <Tablero /> : <InicioCampanas />;
}
